import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Accordion } from "react-bootstrap";

// Images
import bnrImg from "../../images/banner/bnr3.jpg";

// Components
import Question from "../elements/question";

class Faq extends Component {
  render() {
    const questionsLeft = [
      {
        id: 0,
        question: "Hur mycket kostar det att lackera en bil?",
        answer:
          "Priset för att lackera en bil beror på skadans omfattning och vilken typ av lackering som behövs. Kontakta oss för en offert.",
      },
      {
        id: 1,
        question: "Hur dyrt är det att lackera en bil?",
        answer: "Det varierar beroende på bilmodell, färg och typ av arbete. Vi erbjuder konkurrenskraftiga priser.",
      },
    ];

    const questionsRight = [
      {
        id: 0,
        question: "Vad kostar det att lacka om en bil 2024?",
        answer:
          "Det beror på om hela bilen behöver lackeras eller endast vissa delar. Hör av dig för att få mer information och prisförslag.",
      },
      {
        id: 1,
        question: "Vad kostar spot repair?",
        answer:
          "Spot repair är en kostnadseffektiv metod för att reparera mindre skador. Vi kan ge en exakt kostnad baserat på skadans storlek och placering.",
      },
    ];

    return (
      <>
        <div className="page-content bg-white">
          {/* Banner Section */}
          <div className="page-banner ovbl-dark" style={{ backgroundImage: `url(${bnrImg})` }}>
            <div className="container">
              <div className="page-banner-entry text-center">
                <h2 className="banner">
                  <span>FAQ's</span>
                </h2>
                <nav aria-label="breadcrumb" className="breadcrumb-row">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="las la-home"></i> Hem
                      </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      FAQ's
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <section className="section-area section-sp3">
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <Accordion defaultActiveKey="0" className="accordion ttr-accordion style1">
                    {questionsLeft.map((q) => (
                      <Question key={q.id} eventKey={q.id.toString()} question={q.question} answer={q.answer} />
                    ))}
                  </Accordion>
                </div>
                <div className="col-lg-6">
                  <Accordion defaultActiveKey="0" className="accordion ttr-accordion style1">
                    {questionsRight.map((q) => (
                      <Question key={q.id} eventKey={q.id.toString()} question={q.question} answer={q.answer} />
                    ))}
                  </Accordion>
                </div>
              </div>
            </div>
          </section>

          {/* Support Section */}
          <section className="section-area section-sp1">
            <div className="container">
              <div className="heading-bx text-center">
                <h6 className="title-ext text-primary">Inga hjälpsamma svar</h6>
                <h4 className="title mb-0">HÄR ÄR NÅGRA ALTERNATIV</h4>
              </div>
              <div className="row">
                <div className="col-md-12 mb-30">
                  <div className="feature-container bg-gray-alt left feature-bx">
                    <div className="icon-content pl-10">
                      <h5 className="ttr-tilte">FÖR SUPPORT</h5>
                      <p>Du kan kontakta oss via telefon, e-post eller skicka en förfrågan via kontaktformuläret.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}

export default Faq;
